/** Chart-style radio navaid symbols, 2x rasterized for MapLibre. */
export function radioNavaidImage(kind: "VOR" | "VOR/DME" | "DME" | "NDB"): {
  width: number;
  height: number;
  data: Uint8Array;
} {
  const size = 72,
    data = new Uint8Array(size * size * 4),
    center = 36;
  const hex = Array.from({ length: 6 }, (_, i) => [
    center + 24 * Math.cos((i * Math.PI) / 3),
    center + 24 * Math.sin((i * Math.PI) / 3),
  ]);
  const square = [
    [12, 12],
    [60, 12],
    [60, 60],
    [12, 60],
  ];
  const distance = (x: number, y: number, a: number[], b: number[]) => {
    const dx = b[0] - a[0],
      dy = b[1] - a[1],
      t = Math.max(0, Math.min(1, ((x - a[0]) * dx + (y - a[1]) * dy) / (dx * dx + dy * dy)));
    return Math.hypot(x - a[0] - t * dx, y - a[1] - t * dy);
  };
  const edges = (x: number, y: number, p: number[][]) =>
    p.some((a, i) => distance(x, y, a, p[(i + 1) % p.length]) <= 1.7);
  const dots = Array.from({ length: 24 }, (_, i) => [
    center + 26 * Math.cos((i * Math.PI) / 12),
    center + 26 * Math.sin((i * Math.PI) / 12),
  ]);
  for (let y = 0; y < size; y++)
    for (let x = 0; x < size; x++) {
      let coverage = 0;
      for (const oy of [0.25, 0.75])
        for (const ox of [0.25, 0.75]) {
          const px = x + ox,
            py = y + oy,
            r = Math.hypot(px - center, py - center);
          const mark =
            kind === "NDB"
              ? r <= 2.5 || Math.abs(r - 7) <= 1.3 || dots.some((p) => Math.hypot(px - p[0], py - p[1]) <= 1.7)
              : r <= 2.5 ||
                ((kind === "VOR" || kind === "VOR/DME") && edges(px, py, hex)) ||
                ((kind === "DME" || kind === "VOR/DME") && edges(px, py, square));
          if (mark) coverage++;
        }
      data.set([0, 0, 0, Math.round((coverage * 255) / 4)], (y * size + x) * 4);
    }
  return { width: size, height: size, data };
}
